export const FacesheetSummarySkeleton = () => (
  <div
    role="status"
    aria-live="polite"
    aria-label="Loading facesheet"
    className="flex min-h-0 flex-1 overflow-hidden"
  >
    <div className="min-h-0 flex-1 overflow-y-auto">
      <div className="mx-auto flex w-full max-w-5xl flex-col gap-6 p-6">
        <div className="space-y-3">
          <div className="h-8 w-64 animate-pulse rounded bg-neutral-200" />
          <div className="overflow-hidden rounded-md border border-gray-200 bg-white shadow-sm">
            <div className="flex items-end gap-3 border-b border-gray-200 px-4 py-3.5">
              <div className="h-6 w-48 animate-pulse rounded bg-neutral-200" />
              <div className="h-4 w-28 animate-pulse rounded bg-neutral-200" />
              <div className="h-4 w-16 animate-pulse rounded bg-neutral-200" />
            </div>
            <div className="flex gap-6 px-4 py-3.5">
              <div className="h-10 w-32 animate-pulse rounded bg-neutral-200" />
              <div className="h-10 w-72 animate-pulse rounded bg-neutral-200" />
            </div>
          </div>
        </div>

        <div className="space-y-3">
          <div className="h-8 w-48 animate-pulse rounded bg-neutral-200" />
          <div className="overflow-hidden rounded-md border border-gray-200 bg-white shadow-sm">
            <div className="grid grid-cols-[1fr_80px_1fr_128px] gap-4 border-b border-gray-200 px-4 py-3">
              {Array.from({ length: 4 }).map((_, index) => (
                <div
                  key={`facesheet-loading-header-${index}`}
                  className="h-4 animate-pulse rounded bg-neutral-200"
                />
              ))}
            </div>
            {Array.from({ length: 3 }).map((_, rowIndex) => (
              <div
                key={`facesheet-loading-row-${rowIndex}`}
                className="grid grid-cols-[1fr_80px_1fr_128px] gap-4 border-b border-gray-100 px-4 py-4 last:border-b-0"
              >
                {Array.from({ length: 4 }).map((_, colIndex) => (
                  <div
                    key={`facesheet-loading-cell-${rowIndex}-${colIndex}`}
                    className="h-5 animate-pulse rounded bg-neutral-200"
                  />
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>

    <div className="w-[355px] shrink-0 border-l border-neutral-300 bg-neutral-100 px-5 pt-5">
      <div className="mb-4 h-6 w-40 animate-pulse rounded bg-neutral-200" />
      <div className="flex flex-col gap-2">
        <div className="h-8 animate-pulse rounded bg-white" />
        <div className="h-8 animate-pulse rounded bg-neutral-200" />
      </div>
    </div>
    <span className="sr-only">Loading facesheet...</span>
  </div>
);
